module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/de6a2ca491eb20b2b669e732e84ce7af.png";